module.exports = __webpack_public_path__ + "ly.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ly.svg
// module id = 673
// module chunks = 0